import Cookies from 'js-cookie';

const railsEnv = process.env.REACT_APP_RAILS_ENV || process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging';

export const PWA_TOKEN_COOKIE = process.env.REACT_APP_PWA_TOKEN_COOKIE || process.env.PWA_COOKIE_NAME || `pwa_${railsEnv}_session`;

export function getPwaToken(): string {
	return Cookies.get(PWA_TOKEN_COOKIE) || '';
}

export function clearPwaToken(): void {
	Cookies.remove(PWA_TOKEN_COOKIE);

	if (process.env.REACT_APP_DOMAIN_NAME) {
		Cookies.remove(PWA_TOKEN_COOKIE, {
			domain: process.env.REACT_APP_DOMAIN_NAME,
		});
	}
}
